import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { type AllProfilesMember } from '@/types/all-profiles.types';

export const setAllProfilesUsers = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<AllProfilesMember[]>((state, action) => {
    state.allProfiles.users = action.payload;
    state.allProfiles.loadingBase = false;
  });
